import { combineReducers } from "redux";
import {
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_ERROR,
  AUTH_CHECK_REQUEST,
  AUTH_CHECK_SUCCESS,
  AUTH_CHECK_FAIL,
} from "../../../common/constants/action-constants";
import type { AuthActions } from '../actions';

export type AuthState = {
  checked: boolean;
  isAuthed: boolean;
  loading: boolean;
};

const initialState: AuthState = {
    checked: false,
    isAuthed: false,
    loading: false,
};

const auth = (state: AuthState = initialState, action: AuthActions): AuthState => {
  switch (action.type) {
    case AUTH_CHECK_REQUEST:
      return {
        ...state,
        loading: true,
        checked: false,
      };
    case AUTH_CHECK_SUCCESS:
      return {
        ...state,
        loading: false,
        checked: true,
        isAuthed: true,
      };
    case AUTH_CHECK_FAIL:
      return {
        ...state,
        loading: false,
        checked: true,
        isAuthed: false,
      };
    default:
      return state;
  }
}

const receiveUser = (state = {}, action) => {
  switch (action.type) {
    case GET_CURRENT_USER_SUCCESS:
      return action.user;
    default:
      return state;
  }
};

const errorFetchUser = (state = {}, action) => {
  switch (action.type) {
    case GET_CURRENT_USER_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
};

const login = combineReducers({
  receive: receiveUser,
  error: errorFetchUser,
  auth,
});

export default login;
